import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IDeleteUserNotificationRequestParams {
    id: string;
  }

export class DeleteUserNotificationRequest extends Request<IDeleteUserNotificationRequestParams, {}> {
  constructor(params: IDeleteUserNotificationRequestParams) {
    super('deleteNotificationForUser', params);
  }
}